import request from "@/utils/request"

export function receiveCar(params) {
    return request({
        url: '/business/receive/car',
        method: 'post',
        data: params,
    })
}

export function queryCar(params) {
    return request({
        url: '/business/query/car',
        method: 'post',
        data: params,
    })
}

export function queryMemberByPhone(params) {
    return request({
        url: '/member/query/phone',
        method: 'post',
        data: params,
    })
}

export function queryUnderRepairCar(params) {
    return request({
        url: '/business/query/underRepair',
        method: 'post',
        data: params,
    })
}

export function queryOrderDetail(params) {
    return request({
        url: '/business/query/order/detail',
        method: 'post',
        data: params,
    })
}

export function saveOrderDetail(params) {
    return request({
        url: '/business/save/order/detail',
        method: 'post',
        data: params,
    })
}

export function removeOrderItem(params) {
    return request({
        url: '/business/remove/order/item',
        method: 'post',
        data: params,
    })
}

export function removeOrderItemMater(params) {
    return request({
        url: '/business/remove/order/materials',
        method: 'post',
        data: params,
    })
}

export function settleOrder(params) {
    return request({
        url: '/business/settle/order',
        method: 'post',
        data: params,
    })
}

export function cancelSettleOrder(params) {
    return request({
        url: '/business/settle/order/cancel',
        method: 'post',
        data: params,
    })
}

export function queryCashierWorkOrder(params) {
    return request({
        url: '/business/query/order/cashier',
        method: 'post',
        data: params,
    })
}

export function saveCashierWorkOrder(params) {
    return request({
        url: '/business/save/order/cashier',
        method: 'post',
        data: params,
    })
}

export function cancelCashier(params) {
    return request({
        url: '/business/cancel/order/cashier',
        method: 'post',
        data: params,
    })
}

export function writeOff(params) {
    return request({
        url: '/business/cancel/order/writeOff',
        method: 'post',
        data: params,
    })
}

export function queryStoreAllUser(params) {
    return request({
        url: '/user/query/list',
        method: 'post',
        data: params,
    })
}

export function queryMemberById(params) {
    return request({
        url: '/member/query/id',
        method: 'post',
        data: params,
    })
}

export function queryHomeStats(params) {
    return request({
        url: '/stats/home',
        method: 'post',
        data: params,
    })
}
